import React from 'react';
import Button from 'views/components/Button';

const StepNavigation = ({ currentStep, totalSteps, isStepComplete, onPrevious, onContinue, onSubmit, isSubmitting = false }) => {
  const isLastStep = currentStep === totalSteps - 1;

  return (
    <div className="assessment-nav">
      {currentStep !== 0 && <Button text="Previous" color="gray" isInverse onClick={onPrevious} />}
      {isLastStep ? (
        <Button text="Generate My Report" onClick={onSubmit} isDisabled={!isStepComplete} isLoading={isSubmitting} />
      ) : (
        <Button text={currentStep === 0 ? 'Begin Assessment' : 'Continue'} onClick={onContinue} isDisabled={!isStepComplete} />
      )}
    </div>
  );
};

export default StepNavigation;
